import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Cell,
} from "recharts";
import Norming from "./Norming";
import { Box } from "@mui/material";

const CustomTooltip = ({ active, payload, label, data }) => {
  const info = payload?.[0]?.payload;
  if (active && info) {
    return (
      <Paper style={{ padding: 16, maxWidth: 300 }} elevation={15}>
        <Box fontStyle="italic">
          <Typography variant="body2">{info.question}</Typography>
        </Box>
        <Box display={"flex"} style={{ gap: 4 }}>
          <Typography variant="subtitle2">{info.label}:</Typography>
          <Typography variant="body2">{info.primaryScore}</Typography>
          <Typography variant="body2">({info.score}%)</Typography>
        </Box>
        {/*        {info?.norming ? (
          <Box>
            <Typography variant="caption">{info.norming}</Typography>
          </Box>
        ) : null} */}
      </Paper>
    );
  }
  return null;
};

export default function Barchart({ data }) {
  const theme = useTheme();
  const [focusBar, setFocusBar] = useState(null); // index of bar
  const [mouseLeave, setMouseLeave] = useState(true);
 // const hasNorming = data.
  return data.length > 0 ? (
    <React.Fragment>
      <ResponsiveContainer height={300}>
        <BarChart
          data={data}
          margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 15,
          }}
          onMouseMove={(state) => {
            if (state.isTooltipActive) {
              setFocusBar(state.activeTooltipIndex);
              setMouseLeave(false);
            } else {
              setFocusBar(null);
              setMouseLeave(true);
            }
          }}
        >
          <XAxis
            dataKey="label"
            angle={-35}
            textAnchor="end"
            height={65}
            interval={0}
            tickFormatter={(label) => {
              if (label.length > 11) {
                return `${label.substring(0, 11)}...`;
              }
              return `${label}`;
            }}
          />
          <YAxis
            domain={[(dataMin) => 0, (dataMax) => 100]}
            interval="preserveStartEnd"
          />
          <CartesianGrid vertical={false} />
          <Tooltip cursor={false} content={<CustomTooltip data={data} />} />
          <Bar
            dataKey="score"
            barSize={30}
            fill={theme.palette.primary.light}
            radius={[theme.shape.borderRadius, theme.shape.borderRadius, 0, 0]}
          >
            {data.map((entry, index) => (
              <Cell
                key={index}
                fill={
                  focusBar === index || mouseLeave
                    ? "#3f89ab"
                    : "rgba(63, 137, 171, 0.2)"
                }
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <Norming data={data} selectedIndex={focusBar} />
    </React.Fragment>
  ) : (
    <div></div>
  );
}
